<template>
  <b-container class="py-4">
    <h1>Settings</h1>
  </b-container>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {

  }
}
</script>

<style>

</style>
